import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper, Typography } from '@mui/material';

import { formatDate } from '../../../shared';

import {
  StyledVerticalContent,
  StyledClaimDetailsStatusHistoryItem,
  StyledProgressTimeline,
  StyledProgressTimelineVertex,
  StyledProgressTimelineEdge,
  StyledClaimDetailsStatusHistoryItemDetails,
} from './ClaimDetailsStatusHistory.styled';

const ClaimDetailsStatusHistory = ({ claim, skipHistoryItem }) => {
  return (
    <Paper>
      <StyledVerticalContent>
        <Typography variant="h3">
          <FormattedMessage id="common.title.history" />
        </Typography>

        <div>
          {claim?.statusHistory
            .filter((historyItem) => !skipHistoryItem.includes(historyItem?.status))
            .map((historyItem, index, items) => {
              const first = index === 0;
              const last = items.length - 1 === index;

              return (
                <StyledClaimDetailsStatusHistoryItem key={historyItem?.date}>
                  <StyledProgressTimeline>
                    <StyledProgressTimelineVertex />
                    <StyledProgressTimelineEdge
                      first={first && !last}
                      last={last && !first}
                      one={last && first}
                    />
                  </StyledProgressTimeline>

                  <StyledClaimDetailsStatusHistoryItemDetails last={last}>
                    {historyItem?.date && (
                      <Typography variant="p" color="product_blue">
                        {formatDate(historyItem?.date)}
                      </Typography>
                    )}

                    <Typography variant="h3">
                      <FormattedMessage id={`claim.history.status.${historyItem?.status}`} />
                    </Typography>
                  </StyledClaimDetailsStatusHistoryItemDetails>
                </StyledClaimDetailsStatusHistoryItem>
              );
            })}
        </div>
      </StyledVerticalContent>
    </Paper>
  );
};

export default ClaimDetailsStatusHistory;
